module.exports = __webpack_public_path__ + "img/seed-selector-logo.1d9171bd.svg";